import {atom} from "jotai";

export const activeMergedFarmIds = atom<string[]>([]);

activeMergedFarmIds.debugLabel = "activeMergedFarmIds";
